import React from "react";
import './DemoContainerMenu.scss'

import menuOpen from './assets/images/demo-menu-open.svg'
import menuClose from './assets/images/demo-menu-close.svg'
import menuColor01 from './assets/images/demo-menu-items/color01.svg'
import menuColor02 from './assets/images/demo-menu-items/color02.svg'
import menuColor03 from './assets/images/demo-menu-items/color03.svg'
import menuColor04 from './assets/images/demo-menu-items/color04.svg'
import menuColor05 from './assets/images/demo-menu-items/color05.svg'


import demoHome from './assets/images/demo-menu-items/demo-home.svg'
import demoResolution from './assets/images/demo-menu-items/demo-resolution.svg'

import gsap from "gsap";

interface DemoContainerMenuProp{
    onStyleChange : (id:number)=>void
    onScaleHandler : ()=>void

    
}


export default class DemoContainerMenu extends React.Component<DemoContainerMenuProp>{

    state = {isOpen:false}
    container = React.createRef<HTMLDivElement>();
    
    componentDidMount = ()=>{
        this.openMenu(false , 0);
    }

    onStyleChange = (id : number)=>{
        this.props.onStyleChange(id);

        this.setState({isOpen : false});
        this.openMenu(false , 0.5);
    }

    onMenuHandler = ()=>{
        this.openMenu(!this.state.isOpen , 0.5);
        this.setState({isOpen : !this.state.isOpen});
        
    }

    openMenu = (open : boolean , time:number)=>{

        gsap.to(this.container.current , {duration:time , height:open ? 400 : 60})
    }

    onResizeHandler = ()=>{
        this.props.onScaleHandler();
        this.setState({isOpen : false});
        this.openMenu(false , 0.5);
        
    }

    render(){
        return (
            <div ref={this.container} className="demo-container-menu">
                <div className="content">
                <img className="demo-container-menu-button" src={!this.state.isOpen ? menuOpen : menuClose} alt="demo menu" onClick={this.onMenuHandler}></img>
                <img className="demo-container-menu-button" src={menuColor01} alt="color 01" onClick={()=>{this.onStyleChange(0)}}></img>
                <img className="demo-container-menu-button" src={menuColor02} alt="color 02" onClick={()=>{this.onStyleChange(1)}}></img>
                <img className="demo-container-menu-button" src={menuColor03} alt="color 03" onClick={()=>{this.onStyleChange(2)}}></img>
                <img className="demo-container-menu-button" src={menuColor04} alt="color 04" onClick={()=>{this.onStyleChange(3)}}></img>
                <img className="demo-container-menu-button" src={menuColor05} alt="color 05" onClick={()=>{this.onStyleChange(4)}}></img>
                <div className="demo-container-menu-last" >
                    <img className="demo-container-menu-home" src={demoHome} alt="home" onClick={()=>{this.onStyleChange(-1)}}></img>
                    <img className="demo-container-menu-scale" src={demoResolution} alt="resolution" onClick={()=>{this.onResizeHandler()}}></img>
                </div>
                </div>
            </div>
        )
    }
}